import { createContext } from "react";
import type { DashboardDateSelection } from "./dateSelection";
export type { DashboardDateSelection } from "./dateSelection";

export const DashboardDateSelectionContext = createContext<{
  selection: DashboardDateSelection | null;
  remember: (selection: DashboardDateSelection) => void;
}>({ selection: null, remember: () => {} });
